<template>
    <li class="navi-item mt-1">
        <Link as="a"
              class="navi-link py-3 px-4 pr-10"
              :class="{'active': active, 'opacity-50': disabled}"
              :href="disabled ? '#' : url"
                @click="toggle">
            <span class="navi-icon mr-2">
                <i :class="icon"></i>
            </span>
            <span class="navi-text text-nowrap" :class="{'font-weight-bolder': active}">{{ name }}</span>
        </Link>
    </li>
</template>

<script>
import { Link } from '@inertiajs/vue2';

export default {
    name: 'NavigationItem',

    components: {
        Link,
    },

    props: {
        name: String,
        url: String,
        icon: String,
        disabled: Boolean,
    },

    computed: {
        active() {
            let path = '/' + this.url.toString().replace(this.url.urlBuilder.domain, '')
            return path === window.location.pathname
        },
    },

    methods: {
        toggle() {
            this.$emit('toggleNav')
        },
    },
}
</script>

<style>
.navi-icon {
    width: 16px !important;
    text-align: center;
}
</style>
